export default "__VITE_ASSET__CzvZDHif__"